import { csttFacadeApi } from '../csttFacadeApi';
var fetchCustomerByExternalCustomerReference = function (externalCustomerReference) { return csttFacadeApi.get("csttfacade/customer/v1/customers/".concat(externalCustomerReference)); };
export default fetchCustomerByExternalCustomerReference;
